module.exports = "<button class=smss-btn tabindex=0> <span ng-transclude></span> </button> ";